import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import SubCategory from '../views/SubCategory.vue'
import SubItem from '../views/SubItem.vue'
import Cart from '../views/Cart.vue'
import UserDetails from '../views/UserDetails.vue'
import TableSelection from '../views/TableSelection.vue'
import Payment from '../views/Payment.vue'
import OrderDetails from '../views/OrderDetails.vue'
import TimeSlotSelection from '../views/TimeSlotSelection.vue'
import CategoryCategory from "../views/CategoryCategory.vue"
import Main from '../views/Main.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/:menuHash?/:tableId?',
    name: 'Home',
    component: Home,
    meta: { transition: 'fade' }
    
  },
  {
    path: '/:menuHash?/:tableId?/cart',
    name: 'Cart',
    component: Cart,
    meta: { transition: 'fade' }
  },
  {
    path: '/:menuHash?/:tableId?/order-details',
    name: 'OrderDetails',
    component: OrderDetails,
    meta: { transition: 'fade' }
  },
  {
    path: '/:menuHash?/cart/user-details',
    name: 'UserDetails',
    component: UserDetails,
    meta: { transition: 'fade' }
  },
  {
    path: '/:menuHash?/cart/table-selection',
    name: 'TableSelection',
    component: TableSelection,
    meta: { transition: 'fade' }
  },
  {
    path: '/:menuHash?/cart/time-slot-selection',
    name: 'TimeSlotSelection',
    component: TimeSlotSelection,
    meta: { transition: 'fade' }
  },
  {
    path: '/:menuHash?/cart/payment',
    name: 'Payment',
    component: Payment,
    meta: { transition: 'fade' }
  },
  {
    path: '/:menuHash/sub/:subCategoryId?',
    name: 'SubCategory',
    component: SubCategory,
    meta: { transition: 'fade' }
  },
  {
    path: '/:menuHash/sub/:subCategoryId?/category/:categoryId/',
    name: 'Category',
    component: Main,
    meta: { transition: 'fade' }
  },
  {
    path: '/:menuHash/sub/:subCategoryId?/category/:categoryId/menuItemId/:menuItemId',
    name: 'SubItem',
    component: SubItem,
    meta: { transition: 'fade' }
  },
  {
    path: '/:menuHash/category/:categoryId',
    name: 'CategoryCategory',
    component: CategoryCategory,
    meta: { transition: 'fade' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
